<p>
  This information will be used to estimate your age so we can project when
  you will be eligible to retire. It will also be used for life expectancy
  estimates that go into certain calculations within the tool.
</p>
<p>
  To limit the amount of personal data you need to enter – and because the
  tool’s results are rough estimates – we require only your month and year of
  birth.
</p>